import { Modal } from 'antd';
import type { TFunction } from 'i18next';
import type { WebsiteMediaItem } from '../graphql/types';
import { formatLocalDateTime } from '../utils/format';

/** 当前排队中的询问：多个文件同时上传时逐个弹出，避免确认框叠在一起 */
let pendingAsk: Promise<unknown> = Promise.resolve();

/**
 * 媒体库已有同名、同大小文件时询问运营，作为上传的 confirmDuplicate 选项。
 * [mode] 为 reuse 时确认按钮是「直接使用」（编辑页），为 skip 时是「跳过」（媒体库页）；取消即仍然上传。
 */
export const askDuplicateMedia = (t: TFunction, mode: 'reuse' | 'skip') => (existing: WebsiteMediaItem): Promise<boolean> => {
    const ask = pendingAsk.then(() => new Promise<boolean>((resolve) => {
        Modal.confirm({
            title: t('websiteContent.upload.duplicate.title'),
            content: t('websiteContent.upload.duplicate.content', {
                name: existing.fileName,
                time: formatLocalDateTime(existing.createdAt),
            }),
            okText: t(`websiteContent.upload.duplicate.${mode}`),
            cancelText: t('websiteContent.upload.duplicate.upload'),
            closable: false,
            maskClosable: false,
            keyboard: false,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
        });
    }));
    pendingAsk = ask.catch(() => undefined);
    return ask;
};

/** 自动生成的文件（如视频截帧海报）：同名同大小即为同一张，直接使用已有文件，不询问 */
export const reuseDuplicateMedia = (): Promise<boolean> => Promise.resolve(true);
